import axios from 'axios';
import config from '../config/config';

class ProjectApi {
    static getProjects() {
        return axios.get(`${config.server.endpoint}backend/projects`);
    }

    static addProject(payload) {
        return axios.post(`${config.server.endpoint}backend/project`, {
            ...payload
        });
    }

    static editProject(projectId, payload) {
        return axios.put(`${config.server.endpoint}backend/project/${projectId}`, {
            ...payload
        });
    }

    static setCurrentProject(projectId) {
        return axios.put(`${config.server.endpoint}backend/project/current/${projectId}`);
    }
}

export default ProjectApi;
